export const mediumScreenWidth = 746;
export const smallScreenWidth = 576;
